import React from 'react';
import { useClickStreamContext } from '../shared/ClickStream';
import { Title, Text, Button, LeftSide, RightSide } from './CourseTemplateStyled';
import { PlateStyled } from './styles';
import { CourseTemplateProps } from './model';

const CourseTemplate = (props: CourseTemplateProps) => {
  const { logPageEvent } = useClickStreamContext();

  return (
    <PlateStyled>
      <Title>{props.fullTitle}</Title>
      <LeftSide>
        <Text>
          Объем курса – 72 часа
          <br />
          {props.targetAudience}
          <br />
          Дата старта – {props.date.toLowerCase()}
        </Text>
      </LeftSide>
      <RightSide>
        <Button
          as="a"
          target="_blank"
          href={props.link}
          onClick={() =>
            logPageEvent({
              eventType: 'kpk_click_to_go_course_site',
              eventInfo: 'КПК: Клик на кнопку На страницу курса',
              cd1: props.id,
            })
          }
        >
          Записаться
        </Button>
      </RightSide>
    </PlateStyled>
  );
};

export default CourseTemplate;
